import React from 'react';

const Footer = () => {
  return (
    <footer
      style={{
        marginTop: '60px',
        marginBottom: '50px',
        textAlign: 'center',
        opacity: 0.7,
        color: 'grey',
        fontSize: '14px',
      }}
    >
      © {new Date().getFullYear()} {`  `}
      <a href="https://matthewmullin.io"> matthewmullin.io </a>
    </footer>
  );
};

export default Footer;
